/**
 * @generated SignedSource<<549802b43e67112dd5fba3309099c2de>>
 * @relayHash 19ad9a547bce255c35adc444386a03af
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6603bfc1272bd596fb67b3022210270e42d5bfb54ab2cf66470e7e5a8934ba80

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type roadmapSettingsQuery$variables = {
  locationAri?: string | null | undefined;
  sourceAri: string;
};
export type roadmapSettingsQuery$data = {
  readonly roadmaps: {
    readonly roadmapForSource: {
      readonly roadmapConfiguration: {
        readonly boardConfiguration: {
          readonly isSprintsFeatureEnabled: boolean | null | undefined;
          readonly " $fragmentSpreads": FragmentRefs<"childIssuesSchedulingPreview_boardSettingsRoadmap" | "childIssuesSchedulingToggle_boardSettingsRoadmap">;
        };
      };
    } | null | undefined;
  } | null | undefined;
};
export type roadmapSettingsQuery = {
  response: roadmapSettingsQuery$data;
  variables: roadmapSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "locationAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceAri"
},
v2 = [
  {
    "kind": "Variable",
    "name": "locationARI",
    "variableName": "locationAri"
  },
  {
    "kind": "Variable",
    "name": "sourceARI",
    "variableName": "sourceAri"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "isSprintsFeatureEnabled"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "roadmapSettingsQuery",
    "selections": [
      {
        "concreteType": "RoadmapsQuery",
        "kind": "LinkedField",
        "name": "roadmaps",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "RoadmapDetails",
            "kind": "LinkedField",
            "name": "roadmapForSource",
            "plural": false,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "concreteType": "RoadmapConfiguration",
                  "kind": "LinkedField",
                  "name": "roadmapConfiguration",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "concreteType": "RoadmapBoardConfiguration",
                        "kind": "LinkedField",
                        "name": "boardConfiguration",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "FragmentSpread",
                            "name": "childIssuesSchedulingToggle_boardSettingsRoadmap"
                          },
                          {
                            "kind": "FragmentSpread",
                            "name": "childIssuesSchedulingPreview_boardSettingsRoadmap"
                          }
                        ]
                      },
                      "action": "THROW",
                      "path": "roadmaps.roadmapForSource.roadmapConfiguration.boardConfiguration"
                    }
                  ]
                },
                "action": "THROW",
                "path": "roadmaps.roadmapForSource.roadmapConfiguration"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "roadmapSettingsQuery",
    "selections": [
      {
        "concreteType": "RoadmapsQuery",
        "kind": "LinkedField",
        "name": "roadmaps",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "RoadmapDetails",
            "kind": "LinkedField",
            "name": "roadmapForSource",
            "plural": false,
            "selections": [
              {
                "concreteType": "RoadmapConfiguration",
                "kind": "LinkedField",
                "name": "roadmapConfiguration",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "RoadmapBoardConfiguration",
                    "kind": "LinkedField",
                    "name": "boardConfiguration",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "isChildIssuePlanningEnabled"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "childIssuePlanningMode"
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__id"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "6603bfc1272bd596fb67b3022210270e42d5bfb54ab2cf66470e7e5a8934ba80",
    "metadata": {},
    "name": "roadmapSettingsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "31c20159daaa03716587a1ccbe27ab14";

export default node;
